export default __webpack_public_path__ + "static/media/banner-460x200-bg-darkblue-template.13851049.svg";